import { connect, Provider } from 'react-redux';
import SortBy from '@dc/ui-library/src/organisms/SortBy/SortBy';
import ReactDOM from 'react-dom';
import React from 'react';
import uiLocale from '../../../utils/UILocale.js';

export default function initSortBy() {
  const mountEl = document.querySelector('[data-component="list-page-sort-by"]');
  const title = uiLocale.getString('component.sortby.title');

  function mapStateToProps(state) {
    return {
      options: state.listingPage.pageSetup.sortByOptions.optionsList.map(option => ({
        id: option.value,
        label: option.translation
      })),
      selected: state.listingPage.pageSetup.sortByOptions.selectedOptionValue
    };
  }

  const ConnectedSortBy = connect(mapStateToProps)(SortBy);

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedSortBy
          title={title}
          formId="sortForm"
        />
      </Provider>, mountEl
    );
  }
}
